export default __webpack_public_path__ + "static/media/check.aed300c1.svg";